const propertyCollectionsKey = ['properties'];
const propertyTabCountsKey = ['property-tab-counts'];
const propertySearchFormKey = ['search-form'];

export const propertyQueryKeys = {
  collections: propertyCollectionsKey,
  collection: (tab) => [...propertyCollectionsKey, tab],
  tabCounts: propertyTabCountsKey,
  searchForm: propertySearchFormKey,
  detail: (mlsnum) => ['property', mlsnum],
  chat: (mlsnum = null) => ['chat', mlsnum || 'global'],
  recentActivities: (mlsnum = null) => ['recent-activities', mlsnum || 'global'],
  openHouses: (mlsnum = null) => ['open-houses', mlsnum || 'global'],
};
